export enum Languages {
  EnUs = 'en-us',
  ZhCn = 'zh-CN',
  Por = 'pt',
}

export interface LangItems {
  [langName: string]: string,
}

export interface LangConfig {
  default: Languages,
  items: LangItems,
}

const langConfig: LangConfig = {
  default: Languages.EnUs,
  items: {
    [Languages.EnUs]: 'English',
    [Languages.Por]: 'Portuguese',
  },
};

export default langConfig;
